<app-action-button
  [label]="label || btnName"
  [showIcon]="showIcon && isSvgShow"
  [isSvgShow]="showIcon && isSvgShow"
  [disabled]="disabled"
  [routerLink]="routerLink"
  [customClass]="customClass"
  (btnClick)="btnClick.emit($event)"
>
  <ng-content></ng-content>
</app-action-button>

    